<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="main">
    <div class="back">
        <img src="../../../assets/icons/back.svg" class="back-icon" />
        <p (click)="goHome()">Back to home</p>
    </div>
    <div class="header">
        <p class="title">Voice Annotations</p>
        <a class="btn btn-primary my-2  started mx-auto" (click)="deleteRecords()" >Delete Records</a>
        <!-- <a class="view-all">View all data set</a> -->
    </div>
    <form class="uploadForm" [formGroup]="uploadForm" id="uploadForm" (submit)="onSubmit()">
        <div class="form-container">
            <h5 class="sub-heading"><b>Basic Information</b></h5>
            <div class="grid">
                <!-- full name -->
                <div class="col-3">
                    <label class="label"
                    [ngClass]="(contentForm['name'].touched || isSubmitted ) && contentForm['name'].errors?'text-err':''">Full Name<span
                        class="text-err">*</span></label>
                    <input name="name" type="text" formControlName="name" placeholder="Enter full name"
                    class="form-control"
                    [ngClass]="(contentForm['name'].touched || isSubmitted ) && contentForm['name'].errors?'border-err':''" />
                    <p *ngIf="(contentForm['name'].touched || isSubmitted ) && contentForm['name'].errors" class="text-err">
                    Please enter full name</p>
                </div>
                <!-- email -->
                <div class="col-3">
                    <label class="label"
                    [ngClass]="(contentForm['email'].touched || isSubmitted ) && contentForm['email'].errors?'text-err':''">Email Address<span
                        class="text-err">*</span></label>
                    <input name="email" type="email" formControlName="email" placeholder="Enter email"
                    class="form-control"
                    [ngClass]="(contentForm['email'].touched || isSubmitted ) && contentForm['email'].errors?'border-err':''" />
                    <p *ngIf="(contentForm['email'].touched || isSubmitted ) && contentForm['email'].errors" class="text-err">
                    Please enter valid mail</p>
                </div>
                <!-- gender -->
                <div class="col-3">
                    <label class="label">Gender</label>
                    <div>
                    <p-dropdown styleClass="contentform-select" [options]="allGender" formControlName="selectedGender"
                        [showClear]="true" placeholder="Select" [filter]="true" filterBy="name"
                        optionLabel="name"></p-dropdown>
                    </div>
                    <!-- <p *ngIf="(contentForm['selectedGender'].touched || isSubmitted ) && contentForm['selectedGender'].errors"
                    class="text-err">Please select gender</p> -->
                </div>
            </div>
            <h5 class="sub-heading"><b>Voice Sample</b></h5>
            <label class="label">Click the microphone button below to start recording.</label>
            <p class="note">1. Please make sure to Allow Microphone access to record your voice sample.</p>
            <p class="note">2. Please ensure that you are in a noise-free setting to obtain the best quality voice sample.</p>
            <p class="note">3. Please aim for an audio duration of approximately 50 seconds with uninterrupted speech.</p>
            <p class="note">4. Please make sure the file is in .wav,.mp3 formats.</p>
            <p class="note">5. Please make sure the file doesn't contain any special characters.</p>
            <p class="note">6. It is advised to vary your speaking style by using different tones and paces to enhance the model's training effectively.</p>
            <div class="grid">
                <div class="col-4 mx-auto">
                    <app-audio-recorder (recordEvent)="onRecordEvent($event)"></app-audio-recorder>
                </div>
                <div class="col-4 text-center my-auto"> OR </div>
                <div class="col-4 upload_container mx-auto flex justify-content-center align-items-center">
                    <app-upload (fileEvent)="onUploadEvent($event)" accepted_formats=".wav,.mp3" [db_store]="false" [display_event_data]="false"></app-upload>
                </div>
            </div>
            <div class="grid" *ngIf="audio_url">
                <div class="col-4">
                    <app-audio-component [src]="audio_url"></app-audio-component>
                </div>
            </div>
        </div>
        <hr class="dash">
        <div class="form-btn-group">
            <button class="btn btn-secondary" (click)="goHome()">Cancel</button>
            <button type="submit" class="btn btn-dark" [class]="uploadForm.valid?'':'btn-disabled'" [disabled]="!uploadForm.valid">Save</button>
        </div>   
    </form>
</div>